import { render, staticRenderFns } from "./Victory.vue?vue&type=template&id=b191b176&scoped=true&lang=pug&"
import script from "./Victory.vue?vue&type=script&lang=js&"
export * from "./Victory.vue?vue&type=script&lang=js&"
import style0 from "./Victory.vue?vue&type=style&index=0&id=b191b176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b191b176",
  null
  
)

export default component.exports